(() => {
  const initHero = (root) => {
    const slider = root.querySelector('[data-kot-hero-slides]');
    if (!slider || slider.dataset.ready === '1') return;
    slider.dataset.ready = '1';
    const slides = [...slider.querySelectorAll('.hslide')];
    const dots = [...root.querySelectorAll('[data-kot-hero-dot]')];
    if (slides.length < 2 || dots.length !== slides.length) return;

    let index = 0;
    let timer;
    const delay = Number(slider.dataset.delay || 4500);

    const go = (next) => {
      slides[index].classList.remove('on');
      dots[index].classList.remove('on');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('on');
      dots[index].classList.add('on');
    };

    const start = () => {
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), delay);
    };

    dots.forEach((dot, n) => {
      dot.addEventListener('click', () => {
        go(n);
        start();
      });
    });

    start();
  };

  const initKegTabs = (root) => {
    const tabs = [...root.querySelectorAll('[data-kot-keg-tab]')];
    const cards = [...root.querySelectorAll('[data-kot-keg-card]')];
    if (!tabs.length || !cards.length || root.dataset.kegTabsReady === '1') return;
    root.dataset.kegTabsReady = '1';

    tabs.forEach((button) => {
      button.addEventListener('click', () => {
        const category = button.dataset.kotKegTab;
        tabs.forEach((tab) => {
          const active = tab === button;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        cards.forEach((card) => {
          const categories = (card.dataset.cat || '').split(/\s+/);
          card.hidden = !categories.includes(category);
        });
      });
    });
  };

  const initBestTabs = (root) => {
    const tabs = [...root.querySelectorAll('[data-kot-best-tab]')];
    const panels = [...root.querySelectorAll('[data-kot-best-panel]')];
    if (!tabs.length || !panels.length || root.dataset.bestTabsReady === '1') return;
    root.dataset.bestTabsReady = '1';

    tabs.forEach((button) => {
      button.addEventListener('click', () => {
        const tab = button.dataset.kotBestTab;
        tabs.forEach((item) => {
          const active = item === button;
          item.classList.toggle('active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.kotBestPanel !== tab;
        });
      });
    });
  };

  const initFaq = (root) => {
    const items = [...root.querySelectorAll('.qa')];
    if (!items.length || root.dataset.faqReady === '1') return;
    root.dataset.faqReady = '1';

    items.forEach((item) => {
      const button = item.querySelector(':scope > button');
      if (!button) return;
      button.addEventListener('click', () => {
        const willOpen = !item.hasAttribute('open');
        items.forEach((other) => other.removeAttribute('open'));
        if (willOpen) item.setAttribute('open', '');
      });
    });
  };

  const initRoot = (root) => {
    initHero(root);
    initKegTabs(root);
    initBestTabs(root);
    initFaq(root);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('.kot-home')) initRoot(scope);
    scope.querySelectorAll?.('.kot-home').forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
